export enum QFromToType{
    Number = 0,
    Date = 1,
    Time = 2,
    DateTime = 3
}

// export class QFromToIndicatorModel {
// }
